var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
				'success-btn button',
				'size-'+_vm.size,
				'width-'+_vm.width ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClick($event)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }